import find from 'lodash.find';

WB.DataManagers = WB.DataManagers || {};
WB.DataManagers.Locations = function (_User, LocationsDataService, LocationUtility, DataManagerUtility) {

    this.FromFavoriteLocations = function() {
        return _User.FavoriteLocations.map(function(favorite) {
            return favorite.Location;
        });
    };

    this.HasNonDefaultStation = function(location) {
        return location.Station && (location.DefaultStationRouteString !== location.Station.RouteString);
    };

    this.Update = function (location) {
        if (_User.ActiveLocation.Id == location.Id) {
            _User.ActiveLocation = location;
        }
        return LocationsDataService.UpdateLocation(location);
    };

    this.IsEqual = function(l1, l2) {
        var sameLocality = l1.Locality.CityId == l2.Locality.CityId;
        var sameNullStation = (l1.Station == null && l2.Station == null);
        var sameNotNullStation = (l1.Station && l2.Station) && (l1.Station.StationId == l2.Station.StationId);

        return sameLocality && (sameNullStation || sameNotNullStation);
    };

    this.GetLocationForLatLng = function(lat, lng) {
        var key = LocationUtility.GetCoordinateAsKey({
            Latitude: lat,
            Longitude: lng,
            Units: _User.Units
        });
        var resolver = DataManagerUtility.GetCache({
            name: 'LocationsByLatLng',
            signature: key
        });

        if (resolver) {
            return resolver;
        } else {
            var newCache = {
                name: 'LocationsByLatLng',
                signature: key,
                value: LocationsDataService.GetLocationForLatLng(lat, lng)
            };
            DataManagerUtility.SetCache(newCache);
            newCache.value.catch(function(err) {
                DataManagerUtility.ClearCache({ name: 'LocationsByLatLng', signature: key });
            });
            return newCache.value;
        }
    };

    this.GetLocalityForLatLng = function(lat, lng) {
        var key = LocationUtility.GetCoordinateAsKey({
            Latitude: lat,
            Longitude: lng,
            Units: _User.Units
        });
        var resolver = DataManagerUtility.GetCache({
            name: 'LocalitiesByLatLng',
            signature: key
        });

        if (resolver) {
            return resolver;
        } else {
            var newCache = {
                name: 'LocalitiesByLatLng',
                signature: key,
                value: LocationsDataService.GetLocalityForLatLng(lat, lng)
            };
            DataManagerUtility.SetCache(newCache);
            newCache.value.catch(function(err) {
                DataManagerUtility.ClearCache({ name: 'LocalitiesByLatLng', signature: key });
            });
            return newCache.value;
        }
    };

};

WB.DataManagers.Locations.$inject = ['_User', 'LocationsDataService', 'LocationUtility', 'DataManagerUtility'];

WB.Core.service('LocationsDataManager', WB.DataManagers.Locations);
